angular.module('manufacturing')
    .factory('ManufacturingOrderRealisation', function ($resource) {
        return $resource('/crm/api/manufacturing-order/:orderId/realisation/:id', {orderId: "@orderId", id: "@id"}, {
            get: {method: 'GET'}
        });
    })
    .controller('ManufacturingOrderProcessQuantityController', function ($rootScope, $uibModalInstance, data, ManufacturingOrder, ManufacturingOrderService, ManufacturingNode, ManufacturingOrderRealisation) {
        this.$onInit = () => {
            this.form = {
                orderId: data.id
            }
            ManufacturingOrder.get({id: data.id}).$promise.then(item => {
                this.loadNodes(item.location.id)
                return this.item = item;
            })
            this.statuses = ManufacturingOrderService.statuses()
        }

        this.loadNodes = (locationId) => {
            ManufacturingNode.autocomplete({size: 1000, locationId: locationId, userOnly: true}).$promise.then(items => {
                if(items.length === 1){
                    this.form.node = items[0];
                }
                return this.nodes = items;
            })
        }

        this.finishOrder = () => {
            this.form.status = "COMPLETED"
        }
        this.cancelFinishOrder = () => {
            delete this.form.status
        }

        this.save = () => {
            return ManufacturingOrderRealisation.save(this.form).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast('manufacturing-order.updated')
                    $rootScope.$broadcast('document.comments.reload')
                })
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
